import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Card } from '@com-delta-idp/mnx-skymiles-shared';
import { Offers } from './models/offers.interfaces';

@Component({
  selector: 'idp-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.scss']
})
export class OffersComponent {
  @Input() content: Offers = {} as Offers;
  @Output() clickAnalyticsEvent = new EventEmitter<Card>();
}
